// extracted by mini-css-extract-plugin
module.exports = {"notificationWrapper":"CheckoutNotificationWrapper_notificationWrapper__J0z6t","notificationBox":"CheckoutNotificationWrapper_notificationBox__RXQTw"};